export const TYPE = `URI`
